<template>
    <div class="admin-invoices-page">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">Manage invoices</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card">
                        <div>
                            <div class="row">
                                <div class="col m-3">
                                    <el-popover
                                        placement="left"
                                        title="Filter invoices"
                                        class="float-right"
                                        width="830"
                                        trigger="click">
                                        <base-button slot="reference" outline type="primary" class="filter-btn">
                                            <i class="m-0 ai ai-filter"></i>
                                            <i class="m-0 ai ai-angle-down"></i>
                                        </base-button>
                                        <el-form :model="filter" label-width="100px">
                                            <el-row>
                                                <el-col :span="15">
                                                    <el-form-item label="Date of Issue" label-width="140px">
                                                        <el-date-picker
                                                            v-model="filter.dateOfIssue"
                                                            type="daterange"
                                                            align="center"
                                                            value-format="yyyy-MM-dd"
                                                            start-placeholder="From"
                                                            end-placeholder="To"
                                                            :picker-options="pickerOptions">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="Fulfillment Date" label-width="140px">
                                                        <el-date-picker
                                                            v-model="filter.fulfillmentDate"
                                                            type="daterange"
                                                            align="center"
                                                            value-format="yyyy-MM-dd"
                                                            start-placeholder="From"
                                                            end-placeholder="To"
                                                            :picker-options="pickerOptions">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                    <el-form-item label="Due Date" label-width="140px">
                                                        <el-date-picker
                                                            v-model="filter.dueDate"
                                                            type="daterange"
                                                            align="center"
                                                            value-format="yyyy-MM-dd"
                                                            start-placeholder="From"
                                                            end-placeholder="To"
                                                            :picker-options="pickerOptions">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </el-col>
                                                <el-col :span="9">
                                                    <el-form-item label="Hotel">
                                                        <el-select v-model="filter.hotel">
                                                            <el-option label="-- All --" :value="null"></el-option>
                                                            <el-option
                                                                v-for="hotel in hotels"
                                                                :key="hotel.billingoId"
                                                                :label="hotel.name"
                                                                :value="hotel.billingoId"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="Status">
                                                        <el-select v-model="filter.status">
                                                            <el-option label="-- All --" :value="null"></el-option>
                                                            <el-option
                                                                v-for="(value, key) in invoiceStatuses"
                                                                :key="key"
                                                                :label="value"
                                                                :value="key"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="Currency">
                                                        <el-select v-model="filter.currency" disabled>
                                                            <el-option label="-- All --" :value="null"></el-option>
                                                            <el-option label="HUF" value="HUF"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <base-button
                                                        type="primary"
                                                        class="float-right"
                                                        @click="filterInvoices(true)">Apply filters
                                                    </base-button>
                                                </el-col>
                                            </el-row>
                                        </el-form>
                                    </el-popover>
                                </div>
                            </div>
                            <el-table class="table-responsive table-flush"
                                      header-row-class-name="thead-light"
                                      :data="invoices"
                                      :empty-text="isLoadingInvoices ? 'Loading...' : 'No Data'"
                                      lazy>

                                <el-table-column label="Hotel" sortable v-slot="{row: invoice}">
                                    {{ invoice.hotel ? invoice.hotel.name : '' }}
                                </el-table-column>

                                <el-table-column label="Invoice No" prop="invoice_no" sortable></el-table-column>

                                <el-table-column label="Date of Issue" prop="date" sortable></el-table-column>

                                <el-table-column
                                    label="Fulfillment Date"
                                    prop="fulfillment_date"
                                    sortable></el-table-column>

                                <el-table-column label="Due Date" prop="due_date" sortable></el-table-column>

                                <el-table-column label="Price" sortable v-slot="{row: invoice}">
                                    {{ invoice.total }} {{ invoice.currency }}
                                </el-table-column>

                                <el-table-column label="Status" sortable v-slot="{row: invoice}">
                                    {{ invoiceStatuses[invoice.status] }}
                                </el-table-column>

                                <el-table-column
                                    label="Actions"
                                    class-name="actions-column"
                                    width="120px"
                                    v-slot="{row: invoice}">
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        content="Download invoice"
                                        placement="top">
                                        <button type="button" @click="downloadInvoice(invoice)">
                                            <i class="ai ai-download text-default"></i>
                                        </button>
                                    </el-tooltip>

                                    <el-popover
                                        v-if="invoice.status === 2"
                                        v-model="showMarkPaidPopover"
                                        placement="left"
                                        width="350"
                                        trigger="click"
                                        @show="showInvoiceQuickAction(invoice)">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Mark as paid"
                                            placement="top"
                                            slot="reference">
                                            <button type="button">
                                                <i class="m-0 ai ai-edit"></i>
                                            </button>
                                        </el-tooltip>

                                        <el-form :model="selectedInvoice" class="mt-2" label-width="140px" size="small">
                                            <el-row>
                                                <el-col>
                                                    <el-form-item label="Payment Method">
                                                        <el-select v-model="selectedInvoice.paymentMethod">
                                                            <el-option
                                                                v-for="pm in paymentMethods"
                                                                :key="pm.id"
                                                                :label="pm.name"
                                                                :value="pm.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                    <el-form-item label="Amount">
                                                        <el-input
                                                            v-model="selectedInvoice.amount"
                                                            disabled
                                                            type="number">
                                                            <template slot="append">
                                                                {{ selectedInvoice.currency }}
                                                            </template>
                                                        </el-input>
                                                    </el-form-item>
                                                    <el-form-item label="Date">
                                                        <el-date-picker
                                                            value-format="yyyy-MM-dd"
                                                            v-model="selectedInvoice.date"
                                                            type="date"></el-date-picker>
                                                    </el-form-item>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col>
                                                    <el-button
                                                        type="danger"
                                                        size="small"
                                                        disabled
                                                        @click="cancelInvoice">Cancel invoice
                                                    </el-button>
                                                    <el-button
                                                        type="primary"
                                                        class="float-right"
                                                        size="small"
                                                        :disabled="!invoiceStatusCanBeChange"
                                                        @click="payInvoice">Mark as Paid
                                                    </el-button>
                                                </el-col>
                                            </el-row>

                                        </el-form>
                                    </el-popover>

                                    <el-popover
                                        v-if="invoice.status === 1"
                                        v-model="showMarkUnpaidPopover"
                                        placement="left"
                                        width="240"
                                        trigger="click"
                                        @show="showInvoiceQuickAction(invoice)">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="Set to unpaid"
                                            placement="top"
                                            slot="reference">
                                            <button type="button">
                                                <i class="m-0 ai ai-remove text-danger"></i>
                                            </button>
                                        </el-tooltip>
                                        <div>Are you sure you want to mark this invoice as unpaid?</div>

                                        <el-button
                                            type="danger"
                                            size="mini"
                                            class="mt-3 float-right"
                                            @click="undoPayment">Mark as unpaid
                                        </el-button>
                                    </el-popover>
                                </el-table-column>
                            </el-table>

                            <div class="card-footer py-4 d-flex justify-content-center">
                                <el-pagination
                                    :total="invoicesCount"
                                    :current-page="currentPage"
                                    layout="prev, pager, next"
                                    background
                                    @current-change="pageChanged"></el-pagination>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import downloadInvoiceMixin from '@/mixins/download-invoice'
    import {
        Col,
        Form,
        FormItem,
        Option,
        Pagination,
        Popover, Row,
        Select, Table,
        TableColumn,
        DatePicker,
        Button
    } from 'element-ui'

    export default {
        mixins: [downloadInvoiceMixin],
        components: {
            [Popover.name]: Popover,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Pagination.name]: Pagination,
            [Select.name]: Select,
            [Option.name]: Option,
            [Row.name]: Row,
            [Col.name]: Col,
            [DatePicker.name]: DatePicker,
            [Button.name]: Button,
        },
        computed: {
            invoiceStatusCanBeChange: {
                get() {
                    const inv = this.selectedInvoice;
                    return inv.date && inv.amount && inv.paymentMethod;
                }
            }
        },
        data() {
            return {
                currentPage: 1,
                itemsPerPage: 10,
                pageCount: 0,
                isLoadingInvoices: true,
                invoices: [],
                hotels: [],
                paymentMethods: [],
                invoicesCount: 0,
                selectedInvoice: {},
                showMarkPaidPopover: false,
                showMarkUnpaidPopover: false,
                filter: {
                    hotel: null,
                    status: null,
                    currency: null,
                },
                filterString: '',
                invoiceStatuses: {
                    1: 'Paid',
                    2: 'Unpaid',
                    4: 'Cancelled',
                },
                dateFilters: ['dateOfIssue', 'fulfillmentDate', 'dueDate'],
                pickerOptions: {
                    firstDayOfWeek: 1,
                    shortcuts: [{
                        text: 'This month',
                        onClick: picker => {
                            const start = this.$moment().startOf('month').format('YYYY-MM-DD');
                            const end = this.$moment().endOf('month').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last month',
                        onClick: picker => {
                            const start = this.$moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                            const end = this.$moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'This year',
                        onClick: picker => {
                            const start = this.$moment().startOf('year').format('YYYY-MM-DD');
                            const end = this.$moment().endOf('year').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: 'Last year',
                        onClick: picker => {
                            const start = this.$moment().subtract(1, 'years').startOf('year').format('YYYY-MM-DD');
                            const end = this.$moment().subtract(1, 'years').endOf('year').format('YYYY-MM-DD');
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
            }
        },
        methods: {
            async getInvoices(query) {
                await this.$axios.get('/api/admin/invoices' + query)
                    .then(res => {
                        this.invoicesCount = parseInt(res.data.count);
                        this.invoices = res.data.data.map(invoice => this.formatInvoice(invoice));
                        // this.pageCount = Math.ceil(res.data / this.itemsPerPage);
                        //console.log('INVOICES', this.invoices);
                    })
                    .catch(err => {
                    })
                    .then(() => {
                        this.isLoadingInvoices = false;
                    })
            },
            async pageChanged(page) {
                this.filter.offset = (page - 1) * this.itemsPerPage;
                this.filterInvoices();
                console.log('NEW PAGE', page);
            },
            filterInvoices(clearOffset) {
                if (clearOffset) {
                    delete this.filter.offset;
                }

                const filterKeys = Object.keys(this.filter).filter(key => !!this.filter[key]);
                const queryString = filterKeys.map(key => {
                    if (this.dateFilters.includes(key)) {
                        return [
                            key + 'From=' + this.filter[key][0],
                            key + 'To=' + this.filter[key][1],
                        ].join('&');
                    } else {
                        return key + '=' + this.filter[key]
                    }

                }).join('&') || null;

                this.getInvoices(queryString ? '?' + queryString : '');

                this.currentPage = 1;
            },
            formatInvoice(invoice) {
                if (invoice.currency === 'HUF') {
                    invoice.total = parseInt(invoice.total);
                }
                return invoice;
            },
            showInvoiceQuickAction(invoice) {
                this.selectedInvoice = {
                    id: invoice.billingo_id,
                    date: this.$moment().format('YYYY-MM-DD'),
                    amount: invoice.total,
                    currency: invoice.currency,
                    paymentMethod: 5,
                };
            },
            payInvoice() {
                this.showMarkPaidPopover = false;
                this.showMarkUnpaidPopover = false;

                this.$axios.post(`/api/admin/invoices/${this.selectedInvoice.id}/pay`, this.selectedInvoice)
                    .then(res => {
                        const invoiceIdx = this.invoices.findIndex(invoice => invoice.id === res.data.id);
                        this.invoices[invoiceIdx] = this.formatInvoice(res.data);
                        this.invoices = [...this.invoices];

                        this.$notify({
                            title: 'Invoice marked as paid',
                        });
                    })
                    .catch(err => {
                        this.$notify({
                            title: 'Opps... Something went wrong',
                            type: 'danger',
                        });
                    });
            },
            undoPayment() {
                this.showMarkPaidPopover = false;
                this.showMarkUnpaidPopover = false;

                this.$axios.delete(`/api/admin/invoices/${this.selectedInvoice.id}/pay`)
                    .then(res => {
                        const invoiceIdx = this.invoices.findIndex(invoice => invoice.id === res.data.id);
                        this.invoices[invoiceIdx] = this.formatInvoice(res.data);
                        this.invoices = [...this.invoices];

                        this.$notify({
                            title: 'Invoice marked as unpaid',
                        });
                    })
                    .catch(err => {
                        this.$notify({
                            title: 'Opps... Something went wrong',
                            type: 'danger',
                        });
                    });
            },
            cancelInvoice() {
                this.showMarkPaidPopover = false;
                this.showMarkUnpaidPopover = false;

                //this.$axios.post(`/api/admin/invoices/${this.selectedInvoice.id}/cancel`)
                //    .then(res => {
                //        const invoiceIdx = this.invoices.findIndex(invoice => invoice.id === res.data.id);
                //        this.invoices[invoiceIdx] = this.formatInvoice(res.data);
                //        this.invoices = [...this.invoices];
                //
                //        this.$notify({
                //            title: 'Invoice cancelled',
                //        });
                //    })
                //    .catch(err => {
                //        this.$notify({
                //            title: 'Opps... Something went wrong',
                //            type: 'danger',
                //        });
                //    });
            },
        },
        async created() {
            this.filterInvoices(true);
            this.hotels = (await this.$axios.get('/api/admin/hotels')).data.data.map(hotel => {
                return {
                    name: hotel.name,
                    billingoId: hotel.billingo_id,
                }
            });

            this.paymentMethods = (await this.$axios.get('/api/admin/payment-methods')).data.data;
        },
    }

</script>
<style lang="scss">
    $unsortedColor: #c0c4cc;
    $sortedColor: #409eff;

    .admin-invoices-page {
        .app-icon {
            display: inline-block;
            width: 40px;
            height: 40px;
            object-fit: cover;
            object-position: center center;
        }
    }

    .card-header-data {
        display: inline-block;
    }

    .pagination {
        margin: auto;
    }

    .filter-btn {
        border: none;
        font-size: 18px;
        padding: 10px 14px;
        float: right;
        margin-bottom: 20px;
    }

    .el-popover__title {
        font-size: 18px;
    }

    .el-select {
        .el-input {
            &:hover {
                .el-input__icon,
                input {
                    color: initial !important;
                }
            }
        }
    }
</style>
